import { INTEGRATION_DISPLAY_NAMES } from '../../../helpers/constants';

/**
 * Resolve the display label for a transaction's booking source.
 *
 * Commission group(s) win over everything else when present — including
 * integrations like FareHarbor — so affiliate bookings surface under the
 * group they belong to instead of the integration name.
 *
 * @param {object} item - A transactions report item.
 * @param {Function} t - i18next translation function.
 * @returns {string} Commission group(s) / Online / agent name / Call Center / integration name.
 */
export const getTransactionSourceLabel = (item, t) => {
    const { transactionSource, transactionAgentName, transactionCommissionGroups } = item;

    if (transactionCommissionGroups?.length) {
        return transactionCommissionGroups.join(', ');
    }
    if (transactionSource === 'widget') {
        return t('bookings.sourceOnline');
    }
    if (transactionSource === 'admin') {
        return transactionAgentName || t('bookings.sourceCallCenter');
    }
    return INTEGRATION_DISPLAY_NAMES[transactionSource] || transactionSource || '';
};

export default getTransactionSourceLabel;
